import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./related-account-contacts.html';
import controller from './RelatedAccountContacts';
import styles from './RelatedAccountContacts-hashed.scss';

/**
 * @ngdoc component
 * @name edge.gateway.contacts.common.app.component: gwRelatedAccountContacts
 *
 * @description  A component to display the contacts accounts related to an account.
 *
 * @param accountNumber {string} the account number for the account
 * @param accountName {string} the account name, used for relationship descriptions
 * @param pageSize: {number} the page size used for pagination.
 * @param relationshipKeysPrefix {string} the prefix for translation keys used for relationship descriptions.
 * The final key is computed by appending '.<relationship code>',or '$all' when no relationship filter is applied.
 * @param detailState: {string} the target state to be transitioned to when the user selects a contact in the list.
 *
 */
export default {
    controller,
    template: cssUtil.hashTemplate(template, styles),
    bindings: {
        accountNumber: '<',
        accountName: '<',
        pageSize: '<',
        relationshipKeysPrefix: '@',
        detailState: '@'
    }
};